import { render, staticRenderFns } from "./LPCATPage.vue?vue&type=template&id=286dc980&scoped=true&"
import script from "./LPCATPage.vue?vue&type=script&lang=js&"
export * from "./LPCATPage.vue?vue&type=script&lang=js&"
import style0 from "./LPCATPage.vue?vue&type=style&index=0&id=286dc980&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "286dc980",
  null
  
)

export default component.exports